import { render, staticRenderFns } from "./CurrencyComponent.vue?vue&type=template&id=27ceeb90&scoped=true"
import script from "./CurrencyComponent.vue?vue&type=script&lang=js"
export * from "./CurrencyComponent.vue?vue&type=script&lang=js"
import style0 from "./CurrencyComponent.vue?vue&type=style&index=0&id=27ceeb90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ceeb90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VTextField})
